import {Injectable} from '@angular/core';

export class ErrorInfo {
  constructor(
    public key: string,
    public message: string,
  ) {}
}

@Injectable({
  providedIn: 'root',
})
export class FileCheckService {
  public checkFile(file: File | null, expectedMediaTypes: string[], maxSizeInBytes: number): ErrorInfo[] {
    const result = [];
    if (!file) {
      result.push(new ErrorInfo('empty', 'Eine Datei scheint leer zu sein.'));
    } else {
      const matchingType = expectedMediaTypes.filter((mediaType: string) => file.type.startsWith(mediaType));
      if (matchingType.length === 0) {
        result.push(new ErrorInfo('type', `${file.name}: Dateien vom Typ "${file.type}" werden nicht unterstützt.`));
      }
      if (file.size > maxSizeInBytes) {
        result.push(new ErrorInfo('size', `${file.name}: Dateien dürfen die Größe von ${Math.round(maxSizeInBytes / 1000000)} MB nicht überschreiten.`));
      }
    }
    return result;
  }
}
